module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/53d2d6182c354c39ef6c27b814613640.png";